import {
  CREATE_INTEGRATION,
  CREATE_INTEGRATION_SUCCESS,
  CREATE_INTEGRATION_ERROR,
  GET_RESPONSE_PARSER_FUNCTIONS,
  GET_RESPONSE_PARSER_FUNCTIONS_SUCCESS,
  GET_RESPONSE_PARSER_FUNCTIONS_ERROR,
  GET_INTEGRATIONS,
  GET_INTEGRATIONS_SUCCESS,
  GET_INTEGRATIONS_ERROR,
  UPDATE_INTEGRATION,
  UPDATE_INTEGRATION_SUCCESS,
  UPDATE_INTEGRATION_ERROR,
  DELETE_INTEGRATION,
  DELETE_INTEGRATION_SUCCESS,
  DELETE_INTEGRATION_ERROR,
  GET_SF_LEAD_INTEGRATION_MACROS,
  GET_SF_LEAD_INTEGRATION_MACROS_SUCCESS,
  GET_SF_LEAD_INTEGRATION_MACROS_ERROR,
  TEST_INTEGRATION,
  TEST_INTEGRATION_SUCCESS,
  TEST_INTEGRATION_ERROR,
  GET_LEAD_INTEGRATION_DEFAULT_PAYLOAD_VALUE,
  GET_LEAD_INTEGRATION_DEFAULT_PAYLOAD_VALUE_SUCCESS,
  GET_LEAD_INTEGRATION_DEFAULT_PAYLOAD_VALUE_ERROR,
  GET_INTEGRATION_TEMPLATES,
  GET_INTEGRATION_TEMPLATES_SUCCESS,
  GET_INTEGRATION_TEMPLATES_ERROR,
  DUPLICATE_INTEGRATIONS,
  DUPLICATE_INTEGRATIONS_SUCCESS,
  DUPLICATE_INTEGRATIONS_ERROR,
  GET_SF_LEAD_INTEGRATION_MACRO_CATEGORIES,
  GET_SF_LEAD_INTEGRATION_MACRO_CATEGORIES_SUCCESS,
  GET_SF_LEAD_INTEGRATION_MACRO_CATEGORIES_ERROR,
  GET_LEAD_INTEGRATION_LOGS_BY_ID,
  GET_LEAD_INTEGRATION_LOGS_BY_ID_SUCCESS,
  GET_LEAD_INTEGRATION_LOGS_BY_ID_ERROR,
  EXPORT_LEAD_INTEGRATION_LOGS,
  EXPORT_LEAD_INTEGRATION_LOGS_SUCCESS,
  EXPORT_LEAD_INTEGRATION_LOGS_ERROR,
  GET_CAMPAIGNS_BY_INTEGRATION,
  GET_CAMPAIGNS_BY_INTEGRATION_SUCCESS,
  GET_CAMPAIGNS_BY_INTEGRATION_ERROR,
  GET_INTEGRATIONS_STATS_BY_DATES_ERROR,
  GET_INTEGRATIONS_STATS_BY_DATES_SUCCESS,
  GET_INTEGRATIONS_STATS_BY_DATES,
  GET_INTEGRATIONS_FAILURE_REASON_STATS_ERROR,
  GET_INTEGRATIONS_FAILURE_REASON_STATS_SUCCESS,
  GET_INTEGRATIONS_FAILURE_REASON_STATS,
  GET_INTEGRATIONS_STATS,
  GET_INTEGRATIONS_STATS_SUCCESS,
  GET_INTEGRATIONS_STATS_ERROR,
  GET_INTERMEDIATE_LEAD_INTEGRATIONS,
  GET_INTERMEDIATE_LEAD_INTEGRATIONS_SUCCESS,
  GET_INTERMEDIATE_LEAD_INTEGRATIONS_ERROR,
  UPDATE_INTERMEDIATE_LEAD_INTEGRATIONS,
  UPDATE_INTERMEDIATE_LEAD_INTEGRATIONS_SUCCESS,
  UPDATE_INTERMEDIATE_LEAD_INTEGRATIONS_ERROR,
  GET_INTEGRATION_SAMPLE_LEADS,
  GET_INTEGRATION_SAMPLE_LEADS_SUCCESS,
  GET_INTEGRATION_SAMPLE_LEADS_ERROR
  } from "./actionTypes"

export const createIntegration = (integration, history) => {
  return {
    type: CREATE_INTEGRATION,
    payload: { integration, history }
  }
}

export const createIntegrationSuccess = integration => {
  return {
    type: CREATE_INTEGRATION_SUCCESS,
    payload: integration
  }
}

export const createIntegrationError = error => {
  return {
    type: CREATE_INTEGRATION_ERROR,
    payload: error
  }
}

export const getResponseParserFunctions = () => {
  return {
    type: GET_RESPONSE_PARSER_FUNCTIONS
  }
}

export const getResponseParserFunctionsSuccess = response_parser_functions => {
  return {
    type: GET_RESPONSE_PARSER_FUNCTIONS_SUCCESS,
    payload: response_parser_functions,
  }
}

export const getResponseParserFunctionsError = error => {
  return {
    type: GET_RESPONSE_PARSER_FUNCTIONS_ERROR,
    payload: error,
  }
}

export const getIntermediateLeadIntegrations = (intermediate_integration_id) => {
  return {
    type: GET_INTERMEDIATE_LEAD_INTEGRATIONS,
    payload: { intermediate_integration_id: intermediate_integration_id },
  }
}

export const getIntermediateLeadIntegrationsSuccess = intermediate_integrations => {
  return {
    type: GET_INTERMEDIATE_LEAD_INTEGRATIONS_SUCCESS,
    payload: intermediate_integrations,
  }
}

export const getIntermediateLeadIntegrationsError = error => {
  return {
    type: GET_INTERMEDIATE_LEAD_INTEGRATIONS_ERROR,
    payload: error,
  }
}

export const updateIntermediateLeadIntegrations = (payload) => {
  return {
    type: UPDATE_INTERMEDIATE_LEAD_INTEGRATIONS,
    payload: payload,
  }
}

export const updateIntermediateLeadIntegrationsSuccess = (payload) => {
  return {
    type: UPDATE_INTERMEDIATE_LEAD_INTEGRATIONS_SUCCESS,
    payload: payload,
  }
}

export const updateIntermediateLeadIntegrationsError = error => {
  return {
    type: UPDATE_INTERMEDIATE_LEAD_INTEGRATIONS_ERROR,
    payload: error,
  }
}

export const getIntegrations = () => {
  return {
    type: GET_INTEGRATIONS
  }
}

export const getIntegrationsSuccess = integration => {
  return {
    type: GET_INTEGRATIONS_SUCCESS,
    payload: integration,
  }
}

export const getIntegrationsError = error => {
  return {
    type: GET_INTEGRATIONS_ERROR,
    payload: error,
  }
}

export const getIntegrationTemplates = () => {
  return {
    type: GET_INTEGRATION_TEMPLATES
  }
}

export const getIntegrationTemplatesSuccess = integrations => {
  return {
    type: GET_INTEGRATION_TEMPLATES_SUCCESS,
    payload: integrations,
  }
}

export const getIntegrationTemplatesError = error => {
  return {
    type: GET_INTEGRATION_TEMPLATES_ERROR,
    payload: error,
  }
}

export const duplicateIntegrations = (integration_ids) => {
  return {
    type: DUPLICATE_INTEGRATIONS,
    loading: true,
    payload: { ids: integration_ids },
    error: null
  }
}

export const duplicateIntegrationsSuccess = integrations => {
  return {
    type: DUPLICATE_INTEGRATIONS_SUCCESS,
    payload: integrations,
  }
}

export const duplicateIntegrationsError = error => {
  return {
    type: DUPLICATE_INTEGRATIONS_ERROR,
    payload: error,
  }
}


export const updateIntegration = (integration, set_loading) => {
  return {
    type: UPDATE_INTEGRATION,
    payload: integration,
    set_loading: set_loading
  }
}

export const updateIntegrationSuccess = integration => {
  return {
    type: UPDATE_INTEGRATION_SUCCESS,
    payload: integration
  }
}

export const updateIntegrationError = error => {
  return {
    type: UPDATE_INTEGRATION_ERROR,
    payload: error
  }
}

export const deleteIntegration = integration => {
  return {
    type: DELETE_INTEGRATION,
    payload: integration
  }
}

export const deleteIntegrationSuccess = integration => {
  return {
    type: DELETE_INTEGRATION_SUCCESS,
    payload: integration
  }
}

export const deleteIntegrationError = error => {
  return {
    type: DELETE_INTEGRATION_ERROR,
    payload: error
  }
}

export const getSfLeadIntegrationMacros = () => {
  return {
    type: GET_SF_LEAD_INTEGRATION_MACROS
  }
}

export const getSfLeadIntegrationMacrosSuccess = integration => {
  return {
    type: GET_SF_LEAD_INTEGRATION_MACROS_SUCCESS,
    payload: integration,
  }
}

export const getSfLeadIntegrationMacrosError = error => {
  return {
    type: GET_SF_LEAD_INTEGRATION_MACROS_ERROR,
    payload: error,
  }
}

export const testIntegration = integration => {
  return {
    type: TEST_INTEGRATION,
    payload: integration,
  }
}

export const testIntegrationSuccess = integration_log => {
  return {
    type: TEST_INTEGRATION_SUCCESS,
    payload: integration_log,
  }
}

export const testIntegrationError = error => {
  return {
    type: TEST_INTEGRATION_ERROR,
    payload: error,
  }
}

export const getLeadIntegrationDefaultPayloadValue = (defaultPayloadValue) => {
  return {
    type: GET_LEAD_INTEGRATION_DEFAULT_PAYLOAD_VALUE,
    payload: defaultPayloadValue,
  }
}

export const getLeadIntegrationDefaultPayloadValueSuccess = defaultPayloadValue => {
  return {
    type: GET_LEAD_INTEGRATION_DEFAULT_PAYLOAD_VALUE_SUCCESS,
    payload: defaultPayloadValue,
  }
}

export const getLeadIntegrationDefaultPayloadValueError = error => {
  return {
    type: GET_LEAD_INTEGRATION_DEFAULT_PAYLOAD_VALUE_ERROR,
    payload: error,
  }
}

export const getSfLeadIntegrationMacroCategories = (macro_category) => {
  return {
    type: GET_SF_LEAD_INTEGRATION_MACRO_CATEGORIES,
    payload: macro_category,
  }
}

export const getSfLeadIntegrationMacroCategoriesSuccess = macro_category => {
  return {
    type: GET_SF_LEAD_INTEGRATION_MACRO_CATEGORIES_SUCCESS,
    payload: macro_category,
  }
}

export const getSfLeadIntegrationMacroCategoriesError = error => {
  return {
    type: GET_SF_LEAD_INTEGRATION_MACRO_CATEGORIES_ERROR,
    payload: error,
  }
}

export const getLeadIntegrationLogsById = (query_params, paginated) => {
  return {
    type: GET_LEAD_INTEGRATION_LOGS_BY_ID,
    payload: query_params, 
    paginated: paginated
  }
}

export const getLeadIntegrationLogsByIdSuccess = (logs, meta = {}) => {
  return {
    type: GET_LEAD_INTEGRATION_LOGS_BY_ID_SUCCESS,
    payload: logs,
    meta,
  }
}

export const getLeadIntegrationLogsByIdError = error => {
  return {
    type: GET_LEAD_INTEGRATION_LOGS_BY_ID_ERROR,
    payload: error,
  }
}

export const exportLeadIntegrationLogs = (payload) => {
  return {
    type: EXPORT_LEAD_INTEGRATION_LOGS,
    payload,
  }
}

export const exportLeadIntegrationLogsSuccess = response => {
  return {
    type: EXPORT_LEAD_INTEGRATION_LOGS_SUCCESS,
    payload: response,
  }
}

export const exportLeadIntegrationLogsError = error => {
  return {
    type: EXPORT_LEAD_INTEGRATION_LOGS_ERROR,
    payload: error,
  }
}

// campaigns by integration
export const getCampaignsByIntegration = (integration_id) => {
  return {
    type: GET_CAMPAIGNS_BY_INTEGRATION,
    payload: integration_id,
  }
}

export const getCampaignsByIntegrationSuccess = campaigns => {
  return {
    type: GET_CAMPAIGNS_BY_INTEGRATION_SUCCESS,
    payload: campaigns,
  }
}

export const getCampaignsByIntegrationError = error => {
  return {
    type: GET_CAMPAIGNS_BY_INTEGRATION_ERROR,
    payload: error,
  }
}
export const getIntegrationStatsByDates = (integration_id) => {
  return {
    type: GET_INTEGRATIONS_STATS_BY_DATES,
    payload: integration_id,
  }
}

export const getIntegrationStatsByDatesSuccess = (integration_stats) => {
  return {
    type: GET_INTEGRATIONS_STATS_BY_DATES_SUCCESS,
    payload: integration_stats,
  }
}

export const getIntegrationStatsByDatesError = error => {
  return {
    type: GET_INTEGRATIONS_STATS_BY_DATES_ERROR,
    payload: error,
  }
}

export const getIntegrationFailureReasonStats = (integration_id) => {
  return {
    type: GET_INTEGRATIONS_FAILURE_REASON_STATS,
    payload: integration_id,
  }
}

export const getIntegrationFailureReasonStatsSuccess = (integration_stats) => {
  return {
    type: GET_INTEGRATIONS_FAILURE_REASON_STATS_SUCCESS,
    payload: integration_stats,
  }
}

export const getIntegrationFailureReasonStatsError = error => {
  return {
    type: GET_INTEGRATIONS_FAILURE_REASON_STATS_ERROR,
    payload: error,
  }
}
export const getIntegrationsStats = (payload) => {
  return {
    type: GET_INTEGRATIONS_STATS,
    payload: payload
  }
}

export const getIntegrationsStatsSuccess = (integration_stats) => {
  return {
    type: GET_INTEGRATIONS_STATS_SUCCESS,
    payload: integration_stats,
  }
}

export const getIntegrationsStatsError = error => {
  return {
    type: GET_INTEGRATIONS_STATS_ERROR,
    payload: error,
  }
}

export const getIntegrationsSampleLeads = () => {
  return {
    type: GET_INTEGRATION_SAMPLE_LEADS,
  }
}

export const getIntegrationsSampleLeadsSuccess = (integration_stats) => {
  return {
    type: GET_INTEGRATION_SAMPLE_LEADS_SUCCESS,
    payload: integration_stats,
  }
}

export const getIntegrationsSampleLeadsError = error => {
  return {
    type: GET_INTEGRATION_SAMPLE_LEADS_ERROR,
    payload: error,
  }
}
